(function($) {

  'use strict';

  var SELECTOR = '.dw_pb_page_list';

  // In order to have the whole row hoverable but maintain the underline on the text, there should be something
  // like a span inside the anchor that gets the underline instead of the anchor itself
  $(SELECTOR).find('.et_pb_module_header a, .entry-title a').each(function() {
    $(this).wrapInner('<span />');
  });

})(jQuery);
